import { FeatureToggles, FeatureToggleService } from 'modules/featureToggle';

export const isToggleReasonModalEnabled = () =>
  FeatureToggleService.isEnabled(FeatureToggles.ReasonBlockModal);
